import RFFInputField from '../../form/RFFInputField';
import RFFCheckbox from '../../form/RFFCheckbox';
import RFFNumberInputField from '../../form/RFFNumberInputField';
import msgs from '../../../config/messages';
import {
  required,
  isEmail,
  isPhoneNumber,
  composeValidators,
  hasFirstAndLastName,
} from '../../../utils/validationUtils';
// import { emailIsValidAndUnsassigned } from '../../../utils/asyncValidations';

export default [
  {
    name: 'name',
    label: msgs.AddUser.fullName,
    placeholder: msgs.AddUser.fullName,
    component: RFFInputField,
    isRequired: true,
    validate: composeValidators(required, hasFirstAndLastName),
    pattern: '[A-Z a-z]{3,}',
    title:
      'Must be alphabet string with 3 or more positions excluding numbers and special chars!',
  },
  {
    name: 'email',
    label: msgs.AddUser.email,
    placeholder: msgs.AddUser.email,
    component: RFFInputField,
    isRequired: true,
    validate: composeValidators(required, isEmail),
  },
  {
    name: 'phoneNumber',
    label: msgs.AddUser.phoneNumber,
    placeholder: msgs.AddUser.phoneNumber,
    component: RFFNumberInputField,
    validate: isPhoneNumber,
    // format: formatString(msgs.AddUser.phoneNumberFormat),
  },
  {
    name: 'faxNumber',
    label: msgs.AddUser.faxNumber,
    placeholder: msgs.AddUser.faxNumber,
    component: RFFNumberInputField,
    validate: isPhoneNumber,
    // format: formatString(msgs.AddUser.phoneNumberFormat),
  },

  {
    name: 'permissions',
    label: ' ',
    component: RFFCheckbox,
    options: [
      {
        text: `Has Permission to Access Messages and Send RFQs to other ICON Members`,
        value: 1,
      },
      {
        text: `Has Permission to Access and Update Tooling Management`,
        value: 2,
      },
      {
        text: `Has Permission to Access and Update Inventory Management`,
        value: 3,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/UserForm/formConfig.jsx